export const GRID_COLUMN_WIDTH = 250;
export const GRID_ROW_HEIGHT = 250;
export const LIST_HEADER_HEIGHT = 55;
export const LIST_ROW_HEIGHT = 60;
export const HYBRID_ROW_HEIGHT = 240;
